<template>
  <div>
    <ContentBlock style="padding: 0 10px 84px 10px;">
      <div class="topTitleContainer">
        <span>状态
          <el-radio-group v-model="form.enableFlag" @change="handleSearch" style="margin-left: 14px;">
            <el-radio-button v-for="op in enableFlagList" :key="op.value" :label="op.value">{{ `${op.label}(${op.num})` }}</el-radio-button>
          </el-radio-group>
        </span>
      </div>
      <TableWithPagination
        class="special"
        :columnList="columnList"
        :tableData="targetLists"
        :toolBar="toolBar"
        :leftToolbar="tableButtons"
        :sortInfo.sync="sortInfo"
        tableBorder="default"
        :showRightToolbar="true"
        :pagination.sync="pagination"
        @size-change="getTargetLists"
        @current-change="getTargetLists"
        @sort-change="getTargetLists"
        :highHoverRow="false"
        :highlightRow="false"
      />
    </ContentBlock>
    <AdvancedSearchComponent ref='JZAdvancedSearchComponent' @updatePageData="updatePageData"></AdvancedSearchComponent>
    <EditBrand ref='JZEditBrandComponent' @handleReset="handleReset" />
  </div>
</template>
<script>
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import { getBrandLists, deleteBrand, changeDisableBrandStatus, getGoodsBrandCount } from '@/api/PlatformSales/Brand';
import icRefresh from '@/assets/table/ic_refresh.svg';
import icAdvanceSearch from '@/assets/table/ic_advanceSearch.svg';
import AdvancedSearchComponent from './component/AdvancedSearchComponent.vue';
import EditBrand from './component/EditBrand.vue';
export default {
  name: 'PlatformSales_Brand',
  components: {
    TableWithPagination,
    AdvancedSearchComponent,
    EditBrand,
  },
  mixins: [TablePaginationMixin],
  computed: {
    tableButtons () {
      return [
        {
          name: '添加品牌',
          status: 'primary',
          size: 'small',
          code: 'addBrand',
          icon: 'vxe-icon--plus',
          permission: '',
          click: this.handleAdd,
        },
      ];
    },
    toolBar () {
      let currentLists = [
        {
          type: 'custom',
          render: () => {
            return (
              <el-input placeholder='请输入品牌名称/品牌简称' style='width:250px;' v-model={this.form.nameOrShortName}>
                <el-button slot="suffix" icon="el-icon-search" onClick={this.handleSearch} style='position: absolute;height: 100%;right: -5px;top: 0;'>
                </el-button>
              </el-input>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            return (
              <vxe-button circle onClick={this.handleAdvancedSearch}>
                <img style='font-size:14px;width:15px;height:15px;' src={icAdvanceSearch} />
              </vxe-button>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            return (
              <vxe-button circle onClick={this.handleReset}>
                <img style='font-size:14px;width:15px;height:15px;' src={icRefresh} />
              </vxe-button>
            );
          },
        },
      ];
      return currentLists;
    },
    columnList () {
      const cols = [
        {
          tooltip: true,
          label: '品牌名称',
          minWidth: '150px',
          width: '',
          prop: 'name',
        },
        {
          tooltip: true,
          label: '品牌简称',
          minWidth: '150px',
          width: '',
          prop: 'shortName',
        },
        {
          tooltip: true,
          label: '品牌图标',
          minWidth: '150px',
          width: '',
          prop: 'logo',
          render: (h, {row}) => {
            if (row.logo) {
              return <div><el-image preview-src-list={[row.logo]} style={'width:40px;height:40px;vertical-align: middle;margin-right:10px'} src={row.logo} ></el-image></div>;
            }
            return '--';
          },
        },
        {
          tooltip: true,
          label: '状态',
          minWidth: '100px',
          width: '',
          prop: 'enableFlagDesc',
        },
        {
          label: '操作',
          prop: 'action',
          width: '150px',
          fixed: 'right',
          render: (h, { row }) => {
            let actions = [];
            actions.push(
              <span class="table-action" onClick={() => this.handleEdit(row)}>
                编辑
              </span>);
            actions.push(
              <span class="table-action" onClick={() => this.handleChangeStatus(row)}>
                {row.enableFlag ? '禁用' : '启用'}
              </span>);
            actions.push(
              <span class="table-action table-action-delete" onClick={() => this.handleDelete(row)}>
                删除
              </span>);
            return h('div', actions);
          },
        },
      ];
      return cols;
    },
  },
  data () {
    return {
      form: {
        name: '',
        shortName: '',
        enableFlag: true,
        nameOrShortName: '',
      },
      targetLists: [],
      enableFlagList: [
        { label: '全部', value: '', num: 0 },
        { label: '已启用', value: true, num: 0 },
        { label: '已禁用', value: false, num: 0 },
      ],
    };
  },
  methods: {
    // 新增品牌
    handleAdd () {
      this.$refs.JZEditBrandComponent.JZForm = {
        name: '',
        shortName: '',
        imageList: [],
      };
      this.$refs.JZEditBrandComponent.currentId = null;
      this.$refs.JZEditBrandComponent.dialogTitle = '添加品牌';
      this.$refs.JZEditBrandComponent.initPage();
    },
    // 编辑
    handleEdit (row) {
      this.$refs.JZEditBrandComponent.JZForm = {
        name: row.name,
        shortName: row.shortName,
        imageList: row.logo ? [{
          url: row.logo,
          name: row.logo.split('/').pop(),
          attachName: row.logo.split('/').pop(),
        }] : [],
      };
      this.$refs.JZEditBrandComponent.dialogTitle = '编辑品牌';
      this.$refs.JZEditBrandComponent.currentId = row.id;
      this.$refs.JZEditBrandComponent.initPage();
    },
    // 切换启用禁用状态
    handleChangeStatus (row) {
      let title = row.enableFlag ? '禁用' : '启用';
      this.$confirm(`确认${title}[${row.name}]吗？`, title).then(() => {
        changeDisableBrandStatus({
          id: row.id,
          enableFlag: !row.enableFlag,
        }).then(() => {
          this.$message.success(`${title}成功`);
          this.handleSearch();
        });
      });
    },
    // 删除
    handleDelete (row) {
      this.$confirm(`确认删除[${row.name}]吗？`, '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'W400',
      }).then(() => {
        deleteBrand({ids: [row.id]}).then(() => {
          this.$message.success('删除成功');
          this.handleSearch();
        });
      });
    },
    handleSearch () {
      getGoodsBrandCount({}).then(({body}) => {
        this.enableFlagList = [
          { label: '全部', value: '', num: (body.disableCount + body.enableCount) },
          { label: '已启用', value: true, num: body.enableCount },
          { label: '已禁用', value: false, num: body.disableCount },
        ];
      });
      this.pagination.currentPage = 1;
      this.getTargetLists();
    },
    handleReset () {
      this.form = this.$options.data().form;
      this.pagination.currentPage = 1;
      this.getTargetLists();
    },
    getTargetLists () {
      const params = {
        ...this.form,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };
      if (this.sortInfo.orderByProperty && this.sortInfo.orderByType) {
        params.orderBy = [this.sortInfo];
      }
      getBrandLists(params).then(({ body }) => {
        this.targetLists = body?.list || [];
        this.pagination.total = body?.total || 0;
      });
    },
    // 高级检索
    handleAdvancedSearch () {
      this.$refs.JZAdvancedSearchComponent.JZForm = JSON.parse(JSON.stringify(this.form));
      this.$refs.JZAdvancedSearchComponent.initPage();
    },
    // 更新数据
    updatePageData (form) {
      this.form = JSON.parse(JSON.stringify(form));
      this.handleSearch();
    },
  },
  created () {
    this.handleSearch();
  },
};
</script>
<style scoped lang='scss'>
/deep/ .topTitleContainer {
  height: 60px;
  background: #FFFFFF;
  box-shadow: inset 0px -1px 0px 0px #DFE2E8;
  border-radius: 6px 6px 0px 0px;
  display: flex;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #606266;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.title-box {
  color: #303133;
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .icon-box {
    display: flex;
    align-items: center;

    img {
      margin-right: 8px;

      &:hover {
        cursor: pointer;
      }
    }

    i {
      &:hover {
        cursor: pointer;
      }
    }
  }
}

/deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #409EFF;
  border-color: #409EFF;
}

/deep/.vxe-tools--wrapper {
  display: flex;
  justify-content: space-between;

  &>.el-button {
    margin-left: 0.5em;
  }

  &>div.el-input {
    margin-left: 0.5em;
  }

  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .vxe-tools--operate {
  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .action {
  color: #409EFF;
  cursor: pointer;

  &:hover {
    color: rgba(64, 158, 255, 0.7);
    text-decoration: underline;
  }
}

/deep/ .el-date-editor.el-input {
  width: -webkit-fill-available;
}
</style>
